module.exports = Promise.resolve(module.bundle.root("8O7rv"))